import { getEnv, types } from "mobx-state-tree";

export const OrganizationSelectorModel = types
  .model({
    organizationId: types.number,
  })
  .actions((self) => ({
    changeOrganization(organizationId: number) {
      self.organizationId = organizationId;
    },

    async updateApplicationWithNewOrganization() {
      await getEnv(self).lastAccessedOrganizationService.updateLastAccessedOrganization(
        self.organizationId
      );
      getEnv(self).currentUserService.setCurrentOrganization(self.organizationId);
      getEnv(self).organizationSubscriptionService.reloadOrganizationSubscription();
    },
  }))
  .views((self) => ({
    get organizationNames() {
      return getEnv(self).currentUserService.currentUser.userOrganizations?.map(
        (organization: any) => {
          return { id: organization.id, name: organization.name || "-" };
        }
      );
    },
  }));
